import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<BrowserRouter data-id="element-281" data-mp="218mo3c3bzv48">
      <App data-id="element-282" data-mp="21ck7lyttmoon" />
    </BrowserRouter>);
}